<template>
  <div class="header-step">
    <template v-for="item in datas">
      <div
        :class="[
          'header-step-num',
          active === item.itemId  ? 'active' : '',
        ]"
        :key="`num${item.itemId}`"
      >
        {{ item.itemId + 1 }}
        <div :class="[
          'header-step-message',
          active === item.itemId ? 'message-active' : '',
        ]">
          {{ item.itemName }}
        </div>
      </div>
      <div
        class="header-step-line"
        :key="item.itemId"
        v-if="item.itemId < datas.length - 1"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datas: [
        { itemId: 0, itemName: "上传身份证" },
        { itemId: 1, itemName: "资料确认" },
        { itemId: 2, itemName: "绑定银行卡" },
        { itemId: 3, itemName: "完成" },
      ],
    };
  },
  props: {
    active: {
      default: 0,
      type: Number,
    },
  },
  mounted() {
    console.log(this.active);
  },
};
</script>

<style lang="less"  scoped>
.header-step {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 64px;
  margin-bottom: 12px;
  margin-top: 60px;
  .header-step-line {
    width: 112px;
    height: 1px;
    background: #fff;
  }
  .header-step-num {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #9fcbff;
    text-align: center;
    line-height: 41px;
    font-size: 24px;
    color: #2487ff;
    .header-step-message {
      position: absolute;
      top: 60px;
      left: -60px;
      width: 160px;
      color: #9fcbff;
    }
		.message-active {
			color: #fff;
		}
  }
  .active {
    color: #2487ff;
    background: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/commonInfo/components/steps.vue